import { render, staticRenderFns } from "./FormulaireJoueurs.vue?vue&type=template&id=04cc2e4d&scoped=true&"
import script from "./FormulaireJoueurs.vue?vue&type=script&lang=js&"
export * from "./FormulaireJoueurs.vue?vue&type=script&lang=js&"
import style0 from "./FormulaireJoueurs.vue?vue&type=style&index=0&id=04cc2e4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cc2e4d",
  null
  
)

export default component.exports